import { render } from "./HeaderComp.vue?vue&type=template&id=2033b1a7"
import script from "./HeaderComp.vue?vue&type=script&lang=js"
export * from "./HeaderComp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ashkan\\Desktop\\Weather\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__